module.exports = __webpack_public_path__ + "img/Logomark2000.e19e9475.png";